import {
  SENTINEL_1_TRANSFER_PERMISSIONS,
  SENTINEL_2_TRANSFER_PERMISSIONS,
  ACATS_PERMISSIONS,
  FRACTIONAL_TRADING_PERMISSIONS,
  LEGIT_PERMISSIONS,
  SKETCH_PERMISSIONS,
  BRAGGART_PERMISSIONS,
  TRADE_PROCESSING_PERMISSIONS
} from 'apex-online-menu'
import { AuthorizationRequestData } from '@Types'

export const ACCOUNTS_VIEW: string[] = ['account.read']
export const CASH_TRANSFERS_VIEW: string[] = ['sentinel2.relationship.read']

export const ACH_TRANSFERS: string[] = [
  'sentinel2.ach.read.enabled',
  'sentinel2.ach.withdrawal.enabled',
  'sentinel2.ach.deposit.enabled'
]
export const ACH_UI_VIEW = ['cash_transfer.UI.ach.view']
export const WIRE_UI_VIEW = ['cash_transfer.UI.wire.view']
export const WIRE_TRANSFERS = ['sentinel2.wire.read.enabled', 'sentinel2.wire.withdrawal.enabled']
export const CHECK_TRANSFERS = ['sentinel2.check.read.enabled', 'sentinel2.check.withdrawal.enabled']
export const CHECK_UI_VIEW = ['cash_transfer.UI.check.view']
export const CHECK_OVERNIGHT_TO_APEX = ['sentinel2.check.overnight_to_apex.enabled']
export const CASH_JOURNAL_TRANSFERS = ['sentinel2.journal.read.enabled', 'sentinel2.journal.enabled']
export const POSITION_JOURNAL_TRANSFERS = ['sentinel2.journal.position.reward.enabled']
export const POSITION_JOURNAL_UI_VIEW = ['cash_transfer.UI.position_journal.view']
export const CASH_JOURNAL_UI_VIEW = ['cash_transfer.UI.journal.view']
export const SCHEDULE_TRANSFERS_READ = ['sts.schedule.read']
export const SCHEDULE_TRANSFERS_UPDATE = ['sts.schedule.update']
export const SCHEDULE_TRANSFERS_CANCEL = ['sts.schedule.cancel']
export const CASH_TRANSFER_POSITION_JOURNAL_UI_VIEW = ['cash_transfer.ui.position_journal.view']
export const POSITION_JOURNAL_READ = ['sentinel2.journal.position.read.enabled']
export const POSITION_JOURNAL_REWARD = ['sentinel2.journal.position.reward.enabled']
export const RTP_TRANSFER_DEPOSIT_UPDATE = ['sentinel2.real-time-payment.deposit.enabled']
export const RTP_TRANSFER_WITHDRAWAL_UPDATE = ['sentinel2.real-time-payment.withdrawal.enabled']
export const ALL_REQUESTED_PERMISSIONS: string[] = [
  ...ACCOUNTS_VIEW,
  ...CASH_TRANSFERS_VIEW,
  ...ACH_TRANSFERS,
  ...ACH_UI_VIEW,
  ...WIRE_UI_VIEW,
  ...WIRE_TRANSFERS,
  ...CASH_JOURNAL_TRANSFERS,
  ...POSITION_JOURNAL_TRANSFERS,
  ...CASH_JOURNAL_UI_VIEW,
  ...CHECK_TRANSFERS,
  ...CHECK_OVERNIGHT_TO_APEX,
  ...CHECK_UI_VIEW,
  ...SENTINEL_1_TRANSFER_PERMISSIONS,
  ...SENTINEL_2_TRANSFER_PERMISSIONS,
  ...ACATS_PERMISSIONS,
  ...FRACTIONAL_TRADING_PERMISSIONS,
  ...LEGIT_PERMISSIONS,
  ...SKETCH_PERMISSIONS,
  ...BRAGGART_PERMISSIONS,
  ...TRADE_PROCESSING_PERMISSIONS,
  ...SCHEDULE_TRANSFERS_READ,
  ...SCHEDULE_TRANSFERS_UPDATE,
  ...SCHEDULE_TRANSFERS_CANCEL,
  ...CASH_TRANSFER_POSITION_JOURNAL_UI_VIEW,
  ...POSITION_JOURNAL_READ,
  ...POSITION_JOURNAL_REWARD,
  ...RTP_TRANSFER_DEPOSIT_UPDATE,
  ...RTP_TRANSFER_WITHDRAWAL_UPDATE
]

export const convertToAuthRequest = (permissions: string[]) => {
  return permissions.map((permission) => {
    return {
      permission
    } as AuthorizationRequestData
  })
}
